import type { CSSProperties } from 'react';

/*
 * Luviamo-logo.
 *
 * Filosofia (SEED 10.4, tarkennettu 7.7.2026 Petrin brandikuvasta): "Luviamo" ISOLLA
 * L-alkukirjaimella, ja i:n piste korvautuu kultaisella auringolla. Kevatpaivan
 * koivumetsa, jossa aurinko nousee. (Aiempi pienaakkosversio oli virheellinen —
 * Premius-palaute #7.)
 *
 * Toteutus:
 *  - i-kirjain on Unicode dotless ı (U+0131), jolloin fontti ei piirra omaa
 *    pistettaan.
 *  - Sun-piste on absoluuttisesti positioitu pseudo-elementti i-kirjaimen
 *    paalla, em-yksikoissa, joten skaalautuu tekstin koon mukana.
 *
 * Saavutettavuus:
 *  - role="img" + aria-label="Luviamo": ruudunlukija lukee "Luviamo".
 *  - Sisaposat aria-hidden, jotteivät ruudunlukijat tartu yksittaisiin
 *    kirjaimiin tai dotless-ı:hin.
 *
 * Kayttoesimerkkeja:
 *   <Logo className="text-xl" />          // Sidebar, Header
 *   <Logo className="text-3xl" />         // Login-sivu, marketing-paikat
 */

type LogoProps = {
  className?: string;
  style?: CSSProperties;
};

export function Logo({ className = '', style }: LogoProps) {
  return (
    <span
      className={`logo ${className}`.trim()}
      style={style}
      role="img"
      aria-label="Luviamo"
    >
      <span aria-hidden="true">
        Luv
        <span className="logo-i">
          {'\u0131'}
          <span className="logo-sun" />
        </span>
        amo
      </span>
    </span>
  );
}
